<script>
/* Components */
import ProductLegalText from './ProductLegalText.vue';
import ProductMarketingSummary from './ProductMarketingSummary.vue';
import EmailSubscribe from './EmailSubscribe.vue';

export default {
  name: 'ProductFootnote',
  components: {
    EmailSubscribe,
    ProductLegalText,
    ProductMarketingSummary,
  },
  props: {
    productHeaderDetails: {
      type: String,
      default: '',
    },
    showProductHeaderDetails: {
      type: Boolean,
      default: false,
    },
    productLegalText: {
      type: String,
      default: '',
    },
    showProductLegalText: {
      type: Boolean,
      default: false,
    },
    productMarketingSummary: {
      type: String,
      default: '',
    },
    showProductMarketingSummary: {
      type: Boolean,
      default: false,
    },
    partNumber: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div id="js__product__footnotes">
    <EmailSubscribe
      v-if="showProductHeaderDetails"
      :key="partNumber"
      :product-header-details="productHeaderDetails"
    />
    <ProductLegalText
      v-if="showProductLegalText"
      :content="productLegalText"
    />
    <ProductMarketingSummary
      v-if="showProductMarketingSummary"
      :content="productMarketingSummary"
    />
  </div>
</template>
